import * as Joi from 'joi';

export const UpdatePOSsSchema = Joi.object({
  posName: Joi.string().trim().min(1).max(500).messages({
    'any.required': 'POS name is required',
    'string.base': 'POS name is invalid.',
    'string.empty': 'POS name is invalid.',
    'string.min': 'POS name must have 1 to 500 characters only.',
    'string.max': 'POS name must have 1 to 500 characters only.',
  }),
}).unknown();
